import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppMainComponent } from '@app-layout/main';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [AppMainComponent, RouterOutlet],
  template: `
    <app-main>
      <div
        pageContent
        style="flex: 1; min-height: 0; display: flex; flex-direction: column;"
      >
        <router-outlet></router-outlet>
      </div>
    </app-main>
  `
})
export class AppShellComponent {}
